import React, { SyntheticEvent, useCallback, useMemo } from 'react';
import { CheckboxBlockField } from './CheckboxBlockField';
import { CheckboxBlockList } from './CheckboxBlockList';
import { useFormikContext } from 'formik';

type Option = {
  label: string;
  value: string;
  required?: boolean;
  icon?: string;
};

interface Props {
  options: Option[];
  label?: string;
  secondaryLabel?: string;
  name: string;
  checkboxClassName?: string;
  noMargin?: boolean;
  onChange?: (e: SyntheticEvent<HTMLInputElement>) => any;
  values?: (string | number)[];
  checkboxListClassName?: string;
  rightAction?: React.ReactNode;
}

export const CheckboxesToArrayField = ({
  options,
  label,
  secondaryLabel,
  name,
  checkboxClassName,
  noMargin,
  onChange,
  values,
  checkboxListClassName,
  rightAction,
}: Props) => {
  const formik = useFormikContext<any>();
  const currentArray: (string | number)[] = useMemo(() => {
    return values || formik?.values[name] || [];
  }, [formik?.values, name, values]);

  const _onChange = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e);
        return;
      }
      const value = e.currentTarget.value;
      const checked = e.currentTarget.checked;

      const newArray = [...currentArray];
      if (checked && !currentArray.includes(value)) {
        newArray.push(value);
      } else if (!checked) {
        const index = newArray.findIndex((val) => val === value);
        if (index === -1) {
          return;
        }
        newArray.splice(index, 1);
      }

      formik.setFieldValue(name, newArray);
    },
    [formik, onChange, currentArray, name],
  );

  return (
    <CheckboxBlockList
      label={label}
      secondaryLabel={secondaryLabel}
      checkboxClassName={checkboxClassName}
      noMargin={noMargin}
      classNameList={checkboxListClassName}
      rightAction={rightAction}
    >
      {options.map((option) => {
        const checked = currentArray.includes(option.value);
        return (
          <CheckboxBlockField
            {...option}
            id={name + '_' + option.value}
            onChange={_onChange}
            readOnly={!!option.required}
            disabled={!!option.required}
            checked={checked}
            key={option.value}
            variant={'green'}
            icon={option.icon}
          />
        );
      })}
    </CheckboxBlockList>
  );
};
